import { useNavigate } from 'react-router-dom';
import { api } from "../../../services";
import { call, put } from 'redux-saga/effects';

import {
    loginRequestSuccess,
    loginRequestFailure,
    doLogoutAppFailure, 
    doLogoutAppSuccess,
    refreshTokenFailure,
    refreshTokenSuccess
} from './actions';

import { getRefreshToken } from "../../../config/cookies";

function* loginRequest(action: any): any {
    const { code } = action.payload;
    const doLogin = () => api.get('auth/callback', {
        params: { code }
    }).then(res => res.data);

    try {
        yield put(loginRequestSuccess(yield call(doLogin)));
    } catch (err: any) {
        yield put(loginRequestFailure(err));
    }
}

function* doLogoutApp(): any {
    const doLogout = () => {
        return api.post('auth/logout', {}, {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( res => res.data)
    }

    try {
        yield put(doLogoutAppSuccess(yield call(doLogout)));
    } catch (error: any) {
        yield put(doLogoutAppFailure(error.message));
    }
}

function* doLogoutAppExit(): any {
    yield put(doLogoutAppSuccess({}));
}

function* refreshToken(): any {

    const doRefreshToken = () => {
        const chave = getRefreshToken();
        const chaveToken = {
            refreshToken: chave
        };
    
        return api.post('auth/refreshToken', chaveToken, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then( res => res.data);
    }

    try {
        yield put(refreshTokenSuccess(yield call(doRefreshToken)));
    } catch (error: any) {
        yield put(refreshTokenFailure(error.message));
    }
}

export {
    loginRequest,
    doLogoutApp,
    refreshToken,
    doLogoutAppExit
}
